import { useQuery } from '@tanstack/react-query';

import { NearByV4Response } from '@src/lib/__generated/api';
import restfulClient from '@src/utils/restfulClient';
const SIXTY_SECONDS = 60_000; // 60 seconds in ms

export async function fetchNearbySlots(params: Record<string, any>) {
	const route = `v4/facilities/${params.facilityCode}/nearby-slots`;

	try {
		const clientResponse: NearByV4Response[] = await restfulClient.post({ route, data: params });

		return clientResponse;
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(error.message);
		} else {
			throw new Error('Failed to fetch nearby slots');
		}
	}
}

export function useGetNearbySlots(params: Record<string, any>) {
	const { error, isPending, data } = useQuery<NearByV4Response[], Error>({
		queryKey: ['getNearbySlots', { params }],
		queryFn: () => fetchNearbySlots(params),
		enabled: !!params.facilityCode,
		staleTime: SIXTY_SECONDS,
	});
	return { error, isPending, data };
}
